export default __webpack_public_path__ + "static/light-bulb-4501f2cc656e8050fb9dd3f92b20cd53.png";